<template>
  <div class="free">
    <div class="free-title">
      {{ $t('checkout.freeProduct') }}
    </div>
    <div class="free-list">
      <div v-for="(item, i) in data" :key="i" class="free-list-item">
        <div class="item-img">
          <img :src="$ossLimit(item.image, 200)" />
        </div>
        <div class="item-info">
          <div class="item-name">
            {{ item.productName }}
          </div>
          <div class="item-count">
            {{ `x${item.quantity}` }}
          </div>
        </div>
        <div class="item-lable">
          {{ $t('checkout.free') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => {},
    },
  },
};
</script>

<style scoped lang="scss">
img {
  width: 100%;
  height: 100%;
}
.free {
  padding: 16px;
  &-title {
    font-size: 12px;
    font-weight: bold;
    padding-bottom: 8px;
  }
  &-list {
    &-item {
      display: flex;
      align-items: center;
      & + & {
        margin-top: 8px;
      }
      .item-img {
        width: 58px;
        height: 58px;
        border-radius: 8px;
        overflow: hidden;
      }
      .item-info {
        align-self: flex-start;
        margin-left: 12px;
        .item-name {
          font-size: 16px;
        }
        .item-count {
          color: #6b7280;
          font-size: 12px;
          margin-top: 4px;
        }
      }
      .item-lable {
        margin-left: auto;
        color: $primary;
      }
    }
  }
}
</style>
